<template>
  <div id="teacher_details">
    <div class="bottombox">
      <Header ref="header" />
      
    </div>
    <!-- bottombox end -->
    <div class="hotgkt">
      <div class="BreadcrumbNavigation">
        您当前所在位置：<a href="/">首页</a> &gt;&gt;
        <router-link :to="{ path: 'teacher_list', query: { nav: 1 } }"
          >教师列表</router-link
        >
        &gt;&gt; <span>{{ Name }}</span>
      </div>
    </div>
    <!-- hotgkt end -->
    <div class="box_top clearfix">
      <div class="fans">
        粉丝<strong>{{ FansCount }}</strong>
      </div>
      <dl class="portrait">
        <dt><img :src="HeadUrl" /></dt>
        <dd>
          <span class="name">{{ Name }}</span>
          <strong class="Referred">{{ JobTitle }}</strong>
          <span class="ckhf" v-if="anys === 1" @click="ljyy">关注</span>
          <span class="yyy" v-else>已关注</span>
        </dd>
      </dl>
      <div class="fans">
        <!-- 高分案例<strong>{{ CaseNum }}</strong> -->
      </div>
    </div>
    <!-- box_top end -->
    <div class="main">
      <div class="main_nav clearfix">
        <div id="tab-tilte2" :class="{ position: position }">
          <ul>
            <li @click="curClick(0)" :class="{ active: cur == 0 }">
              全部<i></i>
            </li>
            <li @click="curClick(1)" :class="{ active: cur == 1 }">
              在售课程<i></i>
            </li>
            <li @click="curClick(2)" :class="{ active: cur == 2 }">
              基本信息<i></i>
            </li>
            <li @click="curClick(3)" :class="{ active: cur == 3 }">
              经验信息<i></i>
            </li>
            <li @click="curClick(5)" :class="{ active: cur == 5 }">
              视频介绍<i></i>
            </li>
            <li @click="curClick(4)" :class="{ active: cur == 4 }">
              学员反馈<i></i>
            </li>
          </ul>
        </div>
      </div>
      <!-- main_nav end -->
      <div id="tab-content" ref="tab_content">
        <div v-show="cur == 1 || cur == 0">
          <div class="course_list">
            <div class="title">
              <span><em></em><strong>在售课程</strong></span>
            </div>
            <ul class="clearfix" v-if="SoldCourses.length > 0">
              <li v-for="(item, index) in SoldCourses">
                <router-link
                  :to="{ path: 'course_details', query: { Id: item.Id } }"
                >
                  <dl>
                    <dt><img :src="item.CoverImg" /></dt>
                    <dd>
                      <h2>{{ item.Title }}</h2>
                      <p class="p0">
                        <span>{{ item.ClassTypeName }}</span>
                      </p>
                      <p class="p1">{{ item.ApplyStudentType }}</p>
                      <div class="p3">
                        <strong>￥{{ item.Price }}</strong>
                      </div>
                    </dd>
                  </dl>
                </router-link>
              </li>
            </ul>
            <div class="theClasss" v-else>
              <img
                src="../../assets/personal/myCourses_img.png"
                alt=""
                class="wuImg"
              />
              <p>暂时没有数据哦~</p>
            </div>
            <div
              class="mores"
              v-if="SoldCourses.length > 4 && zsCourse"
              @click="CourseMores"
            >
              <a>查看更多</a>
            </div>
          </div>
          <!-- course_list end -->
        </div>
        <!-- tab-tilte 0 end -->
        <div v-show="cur == 2 || cur == 0">
          <div class="information">
            <div class="title">
              <span><em></em><strong>基本信息</strong></span>
            </div>
            <div
              class="content clearfix"
              v-if="Idiograph || Academic || LectureCourse || Honor"
            >
              <div v-if="Idiograph">
                <h2>个人签名：</h2>
                <p>{{ Idiograph }}</p>
              </div>
              <div v-if="Academic">
                <h2>学术背景：</h2>
                <p>{{ Academic }}</p>
              </div>
              <div v-if="LectureCourse">
                <h2>讲授课程：</h2>
                <p>{{ LectureCourse }}</p>
              </div>
              <div v-if="Honor">
                <h2>个人荣誉：</h2>
                <p>{{ Honor }}</p>
              </div>
            </div>
            <div class="theClasss" v-else>
              <img
                src="../../assets/personal/myCourses_img.png"
                alt=""
                class="wuImg"
              />
              <p>暂时没有数据哦~</p>
            </div>
          </div>
          <!-- information end -->
        </div>
        <!-- tab-tilte 1 end -->
        <div v-show="cur == 3 || cur == 0">
          <div class="experience">
            <div class="title">
              <span><em></em><strong>经验信息</strong></span>
            </div>
            <div
              class="content clearfix"
              v-if="TeachMethod || ResearchResult || CaseNum > 0"
            >
              <div v-if="TeachMethod">
                <h2>教学理念与方法：</h2>
                <p>{{ TeachMethod }}</p>
              </div>
              <div v-if="ResearchResult">
                <h2>教研成果：</h2>
                <p>{{ ResearchResult }}</p>
              </div>
              <div v-if="CaseNum > 0">
                <h2>高分案例：{{ CaseNum }}个</h2>
                <div class="gfal_box" ref="gfal_box">
                  <p><img v-for="item in gfalList" :src="item" /></p>
                </div>
              </div>
            </div>
            <div class="theClasss" v-else>
              <img
                src="../../assets/personal/myCourses_img.png"
                alt=""
                class="wuImg"
              />
              <p>暂时没有数据哦~</p>
            </div>
            <div
              class="mores"
              v-show="gfalList.length > 4 && gfalNumber"
              @click="clickMore"
            >
              <a>查看更多</a>
            </div>
          </div>
          <!-- experience end -->
        </div>
        <div v-show="cur == 5 || cur == 0">
          <div class="experience">
            <div class="title">
              <span><em></em><strong>视频介绍</strong></span>
            </div>
            <div class="classLive clearfix" v-if="AuditionList.length > 0">
              <ul class="clearfix">
                <li
                  v-for="(item, index) in AuditionList"
                  :key="index"
                  @click="classLiveTan(item.VideoUrl)"
                >
                  <div class="classLive_img">
                    <img :src="item.CoverImg" :title="item.Title" />
                    <strong
                      ><img
                        src="../../assets/courselist/icon_play_A.png"
                        width="66"
                    /></strong>
                    <span>{{ item.VideoTime }}</span>
                  </div>
                  <p>{{ item.TypeName }}</p>
                </li>
              </ul>
            </div>
            <div class="theClasss" v-else>
              <img
                src="../../assets/personal/myCourses_img.png"
                alt=""
                class="wuImg"
              />
              <p>暂时没有数据哦~</p>
            </div>
          </div>
          <!-- experience end -->
        </div>
        <!-- tab-tilte 2 end -->
        <div v-show="cur == 4 || cur == 0">
          <div class="feedback">
            <div class="title">
              <span><em></em><strong>学员反馈</strong></span>
            </div>
            <div class="feedback_li clearfix" v-if="Comments.length > 0">
              <dl class="clearfix" v-for="(item, index) in Comments">
                <dt><img :src="item.HeadUrl" /></dt>
                <dd>
                  <div class="p1 clearfix">
                    <strong>{{ item.NickName }}</strong>
                    <el-rate
                      v-model="item.Score / 2"
                      disabled
                      :colors="colors"
                    ></el-rate
                    ><span>{{ item.AddTime }}</span>
                  </div>
                  <div class="p2 clearfix">
                    <span v-for="(items, index) in arraysList[index]">{{
                      items
                    }}</span>
                    <!-- <span>课堂组织有序</span>
                    <span>教学内容专业</span> -->
                  </div>
                  <div class="p3 clearfix">{{ item.FeedBack }}</div>
                </dd>
              </dl>
            </div>
            <div class="theClasss" v-else>
              <img
                src="../../assets/personal/myCourses_img.png"
                alt=""
                class="wuImg"
              />
              <p>暂时没有数据哦~</p>
            </div>
            <div
              :class="{ CommentsAll: alldata == 0 }"
              class="mores"
              v-show="CommentsAll.length > 8"
              @click="click8(0)"
            >
              <a>查看更多</a>
            </div>
          </div>
          <!-- feedback end -->
        </div>
      </div>
      <!-- tab-content end -->
    </div>
    <!-- main end -->
    <div class="tanZzc" v-if="tanZzc" @click="tanZzcClass"></div>
    <div class="yycg_tan" v-if="ljyycg">
      <p><img src="../../assets/publicClass/yycg_tan.png" width="272" /></p>
      <h2>关注成功</h2>
      <p>
        关注后将会收到该老师的动态信息，<br />
        在个人中心-我的关注-查看您关注过的老师。
      </p>
      <span @click="closeTan">确定</span>
    </div>
    <!-- yycg_tan end -->
    <div class="live_tan" v-if="liveTan">
      <span @click="tanZzcClass"
        ><img src="../../assets/login/close.png"
      /></span>
      <video width="1020" height="574" controls :poster="classImg">
        <source :src="classVideo" />
        您的浏览器不支持 video 标签。
      </video>
    </div>
    <!-- live_tan end -->
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部

import jq from "../../../static/jquery.min.js";
export default {
  name: "App",
  // inject: ['reload'],
  components: {
    // 将组件隐射为标签,登录弹窗
    Header,
    
    jq
  },
  metaInfo() {
    return {
      title: this.setting.title,
      meta: [
        {
          name: "keywords",
          content: "启德考培教师,雅思教师,托福教师,"
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
        }
      ]
    };
  },
  data() {
    return {
      setting: {
        title: "启德考培旗下在线课堂_出国考试在线培训_考培网校"
      },
      tokenkey: "",
      Status: "",
      alldata: 1, //学员信息查看更多
      anys: 1,
      ljyycg: false,
      cur: 0,
      position: false,
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      value1: 3.5,
      value2: 4,
      value3: 7 / 2,
      value4: 2,
      Name: "",
      HeadUrl: "",
      CaseNum: "",
      FansCount: "",
      JobTitle: "",
      Honor: "",
      Academic: "",
      LectureCourse: "",
      Idiograph: "",
      TeachMethod: "",
      ResearchResult: "",
      SoldCoursesAll: [], //在售课程全部数据
      SoldCourses: [], //前4个在售课程数组
      CommentsAll: [], //全部学员反馈
      Comments: [], //前8个学员反馈
      AuditionList: [], //试听视频
      arraysList: [], //学员反馈里的标签
      gfalList: [], //高分案例图片
      gfalNumber: true, //高分案例点击更多后展示开关
      zsCourse: true, //在售课程点击更多后展示开关
      Attention: {
        type: 2,
        ContentId: ""
      },
      tanZzc: false,
      classImg: "",
      classVideo: "",
      liveTan: false //视频弹窗
    };
  },
  mounted: function() {
    //自动触发写入的函数
    let that = this;
    that.tokenkey = that.$cookies.get("token");
    // this.$router.push({query:{nav:1,id:this.$route.query.Id=sessionStorage.getItem("teacherIdBox")}});
    var doc = document.documentElement;
    $(doc).animate(
      {
        scrollTop: 0
      },
      0
    );
    window.addEventListener("scroll", this.menu); //菜单吸顶
    // let teacherId = sessionStorage.getItem("teacherIdBox")

    // // console.log(sessionStorage.getItem("teacherIdBox"))
    var teacherId = this.$route.query.teacherId;
    this.$http
      .get("https://schoolapi.eiceducation.com.cn/api/EicStaff/" + teacherId, {
        headers: {
          token: that.tokenkey
        }
      })
      .then(function(response) {
        // // console.log(response)
        if (response.data.code == 200) {
          console.log("response", response.data.results);
          that.Attention.ContentId = response.data.results.Id;
          that.Name = response.data.results.Name;
          that.setting.title =
            response.data.results.Name 
          that.HeadUrl = response.data.results.HeadUrl;
          that.CaseNum = response.data.results.CaseNum;
          that.FansCount = response.data.results.FansCount;
          that.JobTitle = response.data.results.JobTitle;
          that.Honor = response.data.results.Honor;
          that.Academic = response.data.results.Academic;
          that.LectureCourse = response.data.results.LectureCourse;
          that.Idiograph = response.data.results.Idiograph;
          that.TeachMethod = response.data.results.TeachMethod;
          that.ResearchResult = response.data.results.ResearchResult;
          that.AuditionList = response.data.results.IntroduceList;
          //学员评价
          that.CommentsAll = response.data.results.Comments;
          if (response.data.results.Comments.length > 8) {
            that.Comments = response.data.results.Comments.slice(0, 8); //超过8个显示前8个
          } else {
            //没超过8个全部显示
            that.Comments = response.data.results.Comments;
          }

          that.CaseContent = response.data.results.CaseContent.split(",");
          that.Status = response.data.results.Status;
          that.SoldCoursesAll = response.data.results.SoldCourses;

          if (response.data.results.SoldCourses > 4) {
            that.SoldCourses = response.data.results.SoldCourses.slice(0, 4); //超过4个显示前4个
          } else {
            //没超过4个全部显示
            that.SoldCourses = response.data.results.SoldCourses;
          }

          //判断老师是不是已关注
          if (that.Status) {
            that.anys = 2;
          }
          //高分案例图片
          var gfal = [];
          that.CaseContent.forEach(function(item, i) {
            gfal.push(item);
          });
          that.gfalList = gfal;
          // // console.log(that.gfalList.length)

          //学员反馈
          var arrays = [];
          that.Comments.forEach(function(item, i) {
            arrays.push(item.Label.split(","));
          });
          that.arraysList = arrays;
        }
      })
      .catch(function() {
        // console.log('数据错误');
      });
    //判断登录状态
    if (!that.tokenkey) {
      return;
    }
    that.reloads();
    // if (details == 2) {
    //   this.anys = 2
    // } else {
    //   this.anys = 1
    // }
  },
  methods: {
    ljyy() {
      let that = this;

      if (that.tokenkey) {
        this.$http
          .post(
            "https://schoolapi.eiceducation.com.cn/api/Collection",
            {
              type: 2,
              ContentId: that.Attention.ContentId
            },
            {
              headers: {
                ContentType: "application/json",
                token: that.tokenkey
              }
            }
          )
          .then(function(result) {
            if (result.data.code == 200) {
              // // console.log(result)
              that.anys = 2;
              that.ljyycg = true;
            }
          })
          .catch(function(error) {
            // console.log(error);
          });
      } else {
        // 判断登录弹窗
        return (this.$refs.header.$refs.login.logintc = true);
      }
      //// console.log(that.Attention)
    },
    closeTan() {
      // console.log(this.anys)
      this.ljyycg = false;
      this.anys = 2;
    },
    curClick(index) {
      this.cur = index;
    },
    menu() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.getElementById("app").offsetTop + 500;
      // var offsetTop = this.$refs.tab_content.getBoundingClientRect().top;
      // console.log(this.scroll)
      if (this.scroll > offsetTop) {
        this.position = true;
      } else {
        this.position = false;
      }
    },
    CourseMores() {
      this.SoldCourses = this.SoldCoursesAll;
      this.zsCourse = false;
    },
    // 学员信息点击更多
    click8(a) {
      this.Comments = this.CommentsAll;
      this.alldata = a;
    },
    //点击高分案例更多按钮
    clickMore() {
      this.$refs.gfal_box.style.height = "auto";
      this.gfalNumber = false;
    },
    //点击关注老师按钮

    //加载登录后信息
    reloads() {
      var that = this;
      //收藏状态
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/CollectionStatus?contentId=" +
            this.$route.query.teacherId,
          {
            headers: {
              token: that.tokenkey
            }
          }
        )
        .then(function(response) {
          // // console.log(response)
          if (response.data.code == 200) {
            //判断老师是不是已关注
            that.anys = 2;
          }
        })
        .catch(function() {
          // console.log('数据错误');
        });
    },

    tanZzcClass() {
      this.tanZzc = false;
      this.liveTan = false; //视频弹窗
      this.classVideo = "";
    },
    classLiveTan(classLiveTan) {
      this.tanZzc = true;
      this.liveTan = true; //视频弹窗
      this.classVideo = classLiveTan;
    }
  }
};
</script>

<style scoped>
.CommentsAll {
  display: none;
}

.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.hotgkt {
  background: #fafafa;
}

.BreadcrumbNavigation {
  width: 1180px;
  text-align: left;
  font-size: 16px;
  color: #333;
  line-height: 56px;
  margin: 0 auto;
}

.BreadcrumbNavigation a {
  font-size: 16px;
  color: #333;
}

.BreadcrumbNavigation span {
  font-size: 16px;
  color: #ff4253;
}

.box_top {
  width: 100%;
  height: 88px;
  background: url(../../assets/teacher/topBJ.png) top no-repeat;
  padding-top: 40px;
  position: relative;
  display: flex;
  justify-content: center;
}

.box_top .fans {
  width: 100px;
  margin: 0 24px;
  font-size: 14px;
  color: #ffffff;
  line-height: 30px;
  height: 60px;
  padding-top: 15px;
  text-align: center;
}

.box_top .fans strong {
  display: block;
  font-size: 18px;
  font-weight: 500;
}

.box_top .portrait {
}

.box_top .portrait dt {
  border: 20px #f8f8f8 solid;
  width: 120px;
  height: 120px;
  overflow: hidden;
  background: #fff;
  border-radius: 90px;
  margin: 0 auto;
}

.box_top .portrait dt img {
  display: block;
  width: 100%;
}

.box_top .portrait dd {
  padding-top: 16px;
}

.box_top .portrait dd .name {
  display: block;
  font-size: 32px;
  line-height: 48px;
  color: #333;
  text-align: center;
}

.box_top .portrait dd .Referred {
  display: block;
  line-height: 36px;
  text-align: center;
  font-size: 20px;
  color: #666;
  font-weight: normal;
  margin-bottom: 8px;
}

.box_top .portrait dd .ckhf {
  display: block;
  width: 160px;
  height: 42px;
  background: linear-gradient(180deg, #ffd000 0%, #ffbe42 100%);
  border-radius: 30px;
  font-size: 20px;
  color: #fff;
  line-height: 42px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}

.box_top .portrait dd .yyy {
  display: block;
  width: 160px;
  height: 42px;
  cursor: default;
  background: linear-gradient(180deg, #2fd672 0%, #33c059 100%);
  border-radius: 30px;
  border-radius: 30px;
  font-size: 20px;
  color: #fff;
  line-height: 42px;
  text-align: center;
  margin: 0 auto;
}

.main_nav {
  height: 46px;
  border-bottom: 1px #d5d5d5 solid;
  background: #fff;
  padding-top: 256px;
}

#tab-tilte2 {
  width: 100%;
  height: 46px;
  position: relative;
  z-index: 8;
}

#tab-tilte2.position {
  padding: 5px 0;
  position: fixed;
  left: 0;
  top: 0;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(153, 153, 153, 0.5);
}

#tab-tilte2.position i {
  height: 4px;
  bottom: 5px;
}

#tab-tilte2 ul {
  display: flex;
  justify-content: center;
}

#tab-tilte2 ul li {
  height: 46px;
  margin: 0 21px;
  font-size: 20px;
  color: #333;
  line-height: 44px;
  width: 80px;
  text-align: center;
  cursor: pointer;
  position: relative;
}

#tab-tilte2 ul li.active i {
  display: block;
  width: 32px;
  height: 2px;
  background: #ff4256;
  border-radius: 2px;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -16px;
}

#tab-tilte2 ul li.active {
  color: #ff4256;
}

#tab-content {
  padding-bottom: 72px;
}

#tab-content .title {
  padding-top: 66px;
  height: 86px;
  text-align: center;
}

#tab-content .title span {
  display: inline-block;
  font-size: 28px;
  color: #333333;
  line-height: 56px;
  font-weight: 500;
  padding-right: 12px;
  padding-left: 13px;
  background: url(../../assets/publicClass/main_bottom2.png) right 34px
    no-repeat;
  position: relative;
}

#tab-content .title span em {
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
  background: url(../../assets/publicClass/main_bottom1.png) left top no-repeat;
}

#tab-content .title span strong {
  position: relative;
  font-weight: normal;
}

.course_list {
  width: 1180px;
  margin: 0 auto;
}

.course_list ul {
  padding-bottom: 60px;
}

.course_list ul li {
  width: 280px;
  height: 312px;
  float: left;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
  margin-bottom: 20px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
  position: relative;
}

.course_list ul li:hover {
  box-shadow: 0px 0px 10px 6px #f5f6f6;
}

.course_list ul li:nth-child(4n) {
  margin-right: 0;
}

.course_list ul li dt {
  width: 280px;
  height: 174px;
  overflow: hidden;
}

.course_list ul li dt img {
  width: 280px;
  height: 174px;
}

.course_list ul li dd {
  padding: 0 16px;
  padding-top: 20px;
  text-align: left;
}

.course_list ul li dd h2 {
  font-size: 16px;
  color: #333;
  line-height: 16px;
  margin-bottom: 8px;
  font-weight: normal;
}

.course_list ul li dd .p0 {
  height: 20px;
  margin-bottom: 8px;
}

.course_list ul li dd .p0 span {
  display: inline-block;
  min-width: 60px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
  color: #666;
  background: #f5f6f6;
  border-radius: 10px;
  padding: 0 10px;
  box-sizing: border-box;
}

.course_list ul li dd .p1 {
  width: 100%;
  font-size: 12px;
  color: #4e5cf6;
  line-height: 12px;
  margin-bottom: 8px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.course_list ul li dd .p3 {
  height: 38px;
}

.course_list ul li dd .p3 strong {
  font-size: 24px;
  float: right;
  line-height: 38px;
  color: #333;
}

.course_list ul li dd .p4 {
  font-size: 12px;
  color: #666666;
  position: absolute;
  bottom: 17px;
  right: 16px;
}

.mores a {
  display: block;
  width: 160px;
  height: 36px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #999999;
  line-height: 36px;
  text-align: center;
  font-size: 16px;
  color: #999;
  margin: 0 auto;
  cursor: pointer;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.mores a:hover {
  color: #fff;
  background: #4e5cf6;
  border-color: #4e5cf6;
}

.content {
  width: 1180px;
  margin: 0 auto;
  text-align: left;
}

.content h2 {
  font-size: 20px;
  color: #333;
  line-height: 42px;
  padding: 0 20px;
  margin: 20px 0;
  background: url(../../assets/teacher/h2.png) left no-repeat;
}

.gfal_box {
  overflow: hidden;
  margin-bottom: 20px;
}

.content p {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  font-size: 16px;
  color: #333;
  line-height: 32px;
  padding: 0 20px;
}

.content p img {
  width: 280px;
  margin-bottom: 10px;
}

.feedback {
  width: 1180px;
  margin: 0 auto;
}

.feedback dl {
  border-bottom: 1px #d5d5d5 solid;
  padding: 17px 12px;
  padding-left: 28px;
}

.feedback dl dt {
  border: 3px #f5f6f6 solid;
  width: 42px;
  height: 42px;
  overflow: hidden;
  border-radius: 24px;
  float: left;
  margin-right: 12px;
}

.feedback dl dt img {
  display: block;
  width: 100%;
}

.feedback dl dd {
  width: 1060px;
  float: left;
  text-align: left;
}

.feedback dl dd .p1 {
  height: 28px;
  margin-bottom: 4px;
}

.feedback dl dd .p1 strong {
  color: #333;
  font-size: 16px;
  line-height: 28px;
  float: left;
  margin-right: 8px;
}

.feedback dl dd .p1 .el-rate {
  float: left;
  margin-top: 2px;
}

/deep/ .feedback dl dd .p1 .el-rate__icon {
  font-size: 22px;
}

.feedback .feedback_li {
  margin-bottom: 32px;
}

.feedback dl dd .p1 span {
  float: right;
  font-size: 12px;
  line-height: 22px;
  color: #666;
  padding-top: 6px;
}

.feedback dl dd .p2 {
  height: 20px;
  margin-bottom: 10px;
}

.feedback dl dd .p2 span {
  display: inline-block;
  padding: 0 15px;
  line-height: 20px;
  background: #ffbe42;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
  margin-right: 12px;
}

.feedback dl dd .p3 {
  font-size: 12px;
  color: #666666;
  line-height: 20px;
}

.classLive {
  width: 1156px;
  padding: 0 14px;
  margin: 0 auto;
}

.classLive li {
  width: 280px;
  height: 291px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px #f5f6f6;
  border-radius: 8px;
  margin: 0 4px;
  margin-bottom: 20px;
  overflow: hidden;
  float: left;
}

.classLive li .classLive_img {
  height: 174px;
  position: relative;
  cursor: pointer;
}

.classLive li .classLive_img img {
  width: 100%;
  height: 174px;
}

.classLive li .classLive_img strong {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -33px;
  margin-top: -33px;
  width: 66px;
  height: 66px;
}

.classLive li .classLive_img strong img {
  height: 66px;
}

.classLive li .classLive_img span {
  position: absolute;
  top: 138px;
  left: 204px;
  width: 66px;
  height: 26px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 13px;
  text-align: center;
  line-height: 26px;
  font-size: 14px;
  color: #fff;
}

.classLive li p {
  font-size: 20px;
  line-height: 28px;
  padding: 14px;
}

.tanZzc {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9;
}

.yycg_tan {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 460px;
  height: 520px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(102, 102, 102, 0.6);
  border-radius: 12px;
  margin-left: -230px;
  margin-top: -260px;
  box-sizing: border-box;
  z-index: 9;
}

.yycg_tan img {
  margin: 0 auto;
  /* margin-top: 34px; */
}

.yycg_tan h2 {
  font-size: 20px;
  text-align: center;
  color: #333333;
  line-height: 24px;
  margin-top: -8px;
  margin-bottom: 30px;
}

.yycg_tan p {
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  margin-bottom: 38px;
}

.yycg_tan span {
  display: block;
  width: 160px;
  height: 48px;
  background: linear-gradient(90deg, #7782fb 0%, #4e5cf6 100%);
  border-radius: 30px;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  line-height: 48px;
  margin: 0 auto;
  cursor: pointer;
}

.live_tan {
  width: 1070px;
  height: 659px;
  background: #ffffff;
  border-radius: 12px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -328px;
  margin-left: -535px;
  z-index: 9;
  padding: 0 25px;
  padding-top: 58px;
  box-sizing: border-box;
}

.live_tan span {
  position: absolute;
  top: 12px;
  left: 19px;
  cursor: pointer;
}

.live_tan video {
  border-radius: 12px;
}

.theClasss {
  text-align: center;
}

.theClasss p {
  font-size: 12px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/page2/teacherList/teacher_details.vue